import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { User } from '@getaccept/lib-shared/src/users/types/user';

export class AvatarHelper {
  static getRecipientAvatars = (recipients: Recipient[]) =>
    recipients.map(recipient => ({
      name:
        recipient.fullName ||
        this.getFullName(recipient.firstName, recipient.lastName, recipient.email),
      thumbUrl: recipient.thumbUrl,
    }));

  static getFullName = (firstName: string, lastName: string, email = '') =>
    `${firstName || ''} ${lastName || ''}`.trim() || email.trim();

  static getDisplayName = (recipient: Recipient) =>
    recipient.fullName ||
    this.getFullName(recipient.firstName, recipient.lastName, recipient.email);

  static getImageTransform({ imageScale, imageTranslateX, imageTranslateY }: Partial<User>) {
    return imageScale != null
      ? {
          translateX: imageTranslateX,
          translateY: imageTranslateY,
          scale: imageScale,
        }
      : undefined;
  }
}
